import { render } from "./bankStatementUpload.vue?vue&type=template&id=7e98d160&scoped=true"
import script from "./bankStatementUpload.vue?vue&type=script&lang=js"
export * from "./bankStatementUpload.vue?vue&type=script&lang=js"

import "./bankStatementUpload.vue?vue&type=style&index=0&id=7e98d160&scoped=true&lang=css"

import exportComponent from "/Users/newuser/Herd/spider-project-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e98d160"]])

export default __exports__